import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  imports: [RouterModule],
  selector: 'offconon-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  protected title = 'domain';
}
